<!--
 * @Description: 申请开票弹层
 * @Date: 2024-04-16 11:02:04
-->
<template>
  <el-dialog
    width="90%"
    class="chartDia"
    :show-close="true"
    @close="close"
    :visible="true"
    style="padding:0"
    id="openBill"
  >
    <div slot="title" class="slotTit">申请开票</div>
    <div class="table-box">
      <div class="colorBlock">开票信息</div>
      <div class="search-box">
        <div class="search-left">
          <div>
            <span>开票供应商：</span>
            <dic-select
              @dic-select-obj="saveCompany"
              :fuzzyDef="searchAjaxPro"
              :prop="ProProp"
              ajaxQuery="supplierName"
              :defaultActive="initSupData"
              :ifClearable="false"
              placeholder="开票供应商"
            ></dic-select>
          </div>
          <!-- 服务费发票该字段前置，并有默认值 -->
          <div v-if="is45">
            <span>发票类型：</span>
            <el-select
              v-model="ruleForm.invoiceType"
              placeholder="发票类型"
              style="width: 11.66vw"
            >
              <el-option
                v-for="item in taxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <span>开票类目：</span>
            <dic-select
              @dic-select-obj="saveType"
              :fuzzyDef="searchType"
              :prop="typeProp"
              :assginParams="{ ...ruleForm, ...searchQuery }"
              :setEmpty="setEmpty"
              :defaultActive="initType"
              :ifClearable="false"
              placeholder="开票类目(先选供应商)"
            ></dic-select>
          </div>
          <div v-if="!is45">
            <span>发票类型：</span>
            <el-select
              v-model="ruleForm.invoiceType"
              placeholder="发票类型"
              style="width: 11.66vw"
            >
              <el-option
                v-for="item in taxList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div>
            <span>发票抬头名称：</span>
            <el-input
              v-hovertip="billInfo.enterpriseName"
              slot="reference"
              class="search-input"
              v-model="billInfo.enterpriseName"
              disabled
              clearable
            />
          </div>
          <div>
            <span>联系电话：</span>
            <el-input
              v-hovertip="billInfo.enterprisePhone"
              class="search-input"
              v-model="billInfo.enterprisePhone"
              disabled
              clearable
            />
          </div>
          <div>
            <span>企业税号：</span>
            <el-input
              v-hovertip="billInfo.enterpriseIdentifierNo"
              class="search-input"
              v-model="billInfo.enterpriseIdentifierNo"
              disabled
              clearable
            />
          </div>
          <div>
            <span>开户银行：</span>
            <el-input
              v-hovertip="billInfo.openBank"
              data-set
              class="search-input"
              v-model="billInfo.openBank"
              disabled
              clearable
            />
          </div>
          <div>
            <span>企业地址：</span>
            <el-input
              v-hovertip="billInfo.enterpriseAddress"
              class="search-input"
              v-model="billInfo.enterpriseAddress"
              disabled
              clearable
            />
          </div>
          <div>
            <span>银行账号：</span>
            <el-input
              v-hovertip="billInfo.bankNo"
              :title="billInfo.bankNo"
              class="search-input"
              v-model="billInfo.bankNo"
              disabled
              clearable
            />
          </div>
          <div v-if="billInfo._isSpecial">
            <span>开票方式：</span>
            <el-select
              v-model="ruleForm.invoiceMethod"
              placeholder="开票方式"
              style="width: 11.66vw"
            >
              <el-option
                v-for="item in [
                  { label: '电子发票', value: 1 },
                  { label: '纸质发票', value: 0 }
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!-- <div class="search-right">
          <el-button type="primary" @click="searchEvent">搜索</el-button>
        </div>-->
      </div>
      <div class="colorBlock">发票邮寄信息</div>
      <div class="search-box">
        <div class="search-left">
          <!-- <div>
            <span>选择收件信息：</span>
            <dic-select
              @dic-select-obj="saveAddress"
              :fuzzyDef="searchAddress"
              :prop="addressProp"
              ajaxQuery="supplierName"
              :defaultActive="addressInfo"
              :ifClearable="false"
              placeholder="请选择收件信息"
            ></dic-select>
          </div>-->
          <div>
            <span>收件人：</span>
            <el-input
              v-hovertip="addressInfo.receiptFullName"
              class="search-input"
              v-model="addressInfo.receiptFullName"
              disabled
              clearable
            />
          </div>
          <div>
            <span>联系方式：</span>
            <el-input
              v-hovertip="addressInfo.receiptPhone"
              class="search-input"
              v-model="addressInfo.receiptPhone"
              disabled
              clearable
            />
          </div>
          <div>
            <span>发票邮寄地址：</span>
            <el-input
              v-hovertip="addressInfo.receiptAddress"
              class="search-input"
              v-model="addressInfo.receiptAddress"
              disabled
              clearable
            />
          </div>
          <div>
            <span>收件地址名称：</span>
            <el-input
              v-hovertip="addressInfo.addressName"
              class="search-input"
              v-model="addressInfo.addressName"
              disabled
              clearable
            />
          </div>
          <div>
            <span>电子邮箱：</span>
            <el-input
              v-hovertip="addressInfo.email"
              class="search-input"
              v-model="addressInfo.email"
              disabled
              clearable
            />
          </div>
        </div>
      </div>
      <div class="colorBlock">开票内容</div>
      <div style="display:flex; justify-content: space-between">
        <div>
          <span>支付通道：</span>
          <el-select
            placeholder="支付通道"
            style="width: 150px"
            v-model="searchQuery.payPassagewayCode"
            :disabled="!searchQuery.supplierId"
          >
            <el-option
              v-for="item in BANK_MAPPING"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span>服务商付款方式：</span>
          <el-select
            placeholder="服务商付款方式"
            style="width: 150px"
            v-model="searchQuery[PAY_TYPE_KEY]"
            :disabled="!searchQuery.supplierId"
          >
            <el-option
              v-for="item in PAY_TYPE_MAPPING"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <span>交易结构：</span>
          <el-select
            placeholder="交易结构"
            style="width: 150px"
            clearable
            v-model="searchQuery.professionType"
            :disabled="!searchQuery.supplierId"
          >
            <el-option
              v-for="item in professions"
              :key="item[0]"
              :label="item[1]"
              :value="item[0]"
            ></el-option>
          </el-select>
        </div>
        <div class="totalMoney">
          <label>共：</label>
          <span>{{ selectedList.length }}项</span>
          <label>价税合计：</label>
          <span>{{ curMoney | moneyFixed }}</span>
          <label>最大开票金额：</label>
          <span>{{ tableResp.totalAmount | moneyFixed }}</span>
        </div>
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        ref="openList"
        row-key="id"
        :stripe="true"
        :highlight-current-row="false"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selectable"
          reserve-selection
        ></el-table-column>
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="项目名称"
          prop="projectName"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="交易结构"
        >
          <template slot-scope="{ row }">
            {{ professionFilter(row.professionType) }}
          </template>
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="订单编号"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="toFour(row)">
              {{ row.orderNo }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="订单类型"
        >
          <template slot-scope="{ row }">
            {{ invoiceOrderTypeFilter(row.invoiceOrderType) }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="companyName"
          label="支付对象"
        ></el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="详情"
        >
          <template slot-scope="{ row }">
            {{ row.invoiceOrderType == 1 ? '项目支付' : '综合服务费' }}：{{
            row.taskDt
            }}
          </template>
        </el-table-column> -->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="打款金额"
          key="taskDt"
        >
          <template slot-scope="{ row }">
            {{ row.projectPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="支付通道"
          :key="PAY_BANK_TYPE_KEY"
        >
          <template slot-scope="{ row }">
            {{ payBankFormatter(row) }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="服务商付款方式"
          :key="PAY_TYPE_KEY"
        >
          <template slot-scope="{ row }">
            {{ payTypeFormatter(row) }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="taskDt"
          label="供应商收款时间"
        >
          <template slot-scope="{ row }">
            {{ row.createDt | transAllTime }}
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: left">
        <el-button type="text" @click="empty">清空</el-button>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="paginationData.pageNo"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding: 15px"
      ></el-pagination>
      <div
        style="
          margin: 20px auto;
          display: flex;
          justify-content: space-around;
          width: 30%;
        "
      >
        <el-button
          type="primary"
          @click="next"
          :disabled="selectedList.length === 0"
        >
          下一步
        </el-button>
        <el-button type="primary" plain @click="close">返回</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import { invoice } from '@/api/ajax';
import { openTypeList, taxList, orderTypeList } from '@/config/staticData';
import dicSelect from '@/components/Common/dicSelect.vue';
import { payBankFormatter, payTypeFormatter } from '@/common/fields/bank';
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
import openBill2 from './openBill2.vue';
import createExtend from '@C/createExtend';
import { PROFESSION_TYPE } from './invoiceTable/config/fields';

export default {
  mixins: [pageInation, makeSure],
  components: {
    dicSelect
  },
  props: {
    initSupData: {},
    // 123订单、综合 45平台、商务
    invoiceOrderType: { type: Number, default: 1 }
  },
  computed: {
    BANK_MAPPING() {
      return this.$store.state.bank.banks;
    },
    PAY_TYPE_MAPPING() {
      return this.$store.state.bank.payMethod;
    },
    // 4 5类型
    is45() {
      return [4, 5].includes(this.invoiceOrderType);
    },
    searchAjaxPro() {
      return this.is45 ? invoice.queryBillingProvider : invoice.supplierList;
    },
    searchType() {
      return this.is45
        ? invoice.queryInvoiceServicesItem
        : invoice.supplierItem;
    },
    searchTypeHistory() {
      return this.is45
        ? invoice.queryInvoiceServicesItemLastTime
        : invoice.supplierItemLastTime;
    },
    getList() {
      return this.is45
        ? invoice.servicesOpenInvoiceContent
        : invoice.openInvoiceContent;
    },
    professions() {
      if (this.is45) {
        return PROFESSION_TYPE;
      }
      const professions13 = new Map();
      for (let [key, value] of PROFESSION_TYPE) {
        if ([1, 3].includes(key)) {
          professions13.set(key, value);
        }
      }
      return professions13;
    }
  },
  data() {
    return {
      PAY_BANK_TYPE_KEY,
      PAY_TYPE_KEY,
      payBankFormatter,
      payTypeFormatter,
      openTypeList,
      orderTypeList,
      taxList,
      searchAddress: invoice.queryAllAddressName,
      addressInfo: {
        id: '',
        addressName: '',
        receiptFullName: '',
        receiptPhone: '',
        receiptAddress: ''
      },
      addressProp: {
        label: 'addressName',
        code: 'id'
      },
      ProProp: {
        label: 'supplierName',
        code: 'supplierId'
      },
      typeProp: {
        label: 'itemName',
        code: 'id'
      },
      searchQuery: {
        supplierId: this.initSupData.supplierId || '',
        payPassagewayCode: '',
        payType: '',
        professionType: '',
        invoiceServicesType: '' // 服务费开票，开票类目使用参数。选择供应商后赋值
      },
      gysList: [],
      loading: true,
      selectedList: [],
      ruleForm: {
        itemId: '',
        itemName: '',
        invoiceType: '',
        supplierId: this.initSupData.supplierId,
        supplierName: this.initSupData.supplierName
      },
      setEmpty: 0,
      billInfo: {
        _isSpecial: false
      },
      curMoney: '',
      initType: {
        itemName: '',
        id: ''
      }
    };
  },
  methods: {
    invoiceOrderTypeFilter(invoiceOrderType) {
      if (this.is45) {
        return (
          { 4: '平台服务费发票', 5: '商务服务费发票' }[invoiceOrderType] || '-'
        );
      }
      return orderTypeList[invoiceOrderType - 1].label;
    },
    selectable(row) {
      // newPayStatus   0未支付”、1“支付中”、2“支付成功”  3“支付失败”、  4“线下支付完成  5“关闭支付”、
      return row.newPayStatus !== 5;
    },
    toFour(row) {
      this.$router.push({
        path: '/orderMgmt/list',
        query: {
          orderNo: row.orderNo,
          part: 1,
          payType: row.payType
        }
      });
      this.close();
    },
    saveType(val) {
      this.ruleForm.itemId = val.id;
      this.ruleForm.itemName = val.itemName;
    },
    saveAddress(val) {
      //选择收件地址
      this.addressInfo = val;
    },
    saveCompany(val) {
      this.searchQuery.supplierId = val.supplierId;
      this.searchQuery.invoiceServicesType = val.invoiceServicesType || '';
      this.ruleForm.supplierId = val.supplierId;
      this.ruleForm.supplierName = val.supplierName;
      this.billInfo._isSpecial = val.specialType === 1;
      this.empty();
      this.selectedList = [];
      this.searchEvent();
    },
    handleSelectionChange(val) {
      //选中
      this.selectedList = val;
      let count = 0;
      for (let item of val) {
        count += item.projectPrice;
      }
      this.curMoney = count;
    },
    close() {
      this.$emit('remove');
    },
    empty() {
      this.$refs.openList.clearSelection();
    },
    next() {
      if (!this.ruleForm.itemId) {
        this.$message({
          type: 'warning',
          message: '开票类目不能为空'
        });
        return;
      }
      if (!this.ruleForm.invoiceType) {
        this.$message({
          type: 'warning',
          message: '发票类型不能为空'
        });
        return;
      }
      if (
        ![0, 1].includes(this.ruleForm.invoiceMethod) &&
        this.billInfo._isSpecial
      ) {
        this.$message({
          type: 'warning',
          message: '开票方式不能为空'
        });
        return;
      }
      if (!this.addressInfo.id) {
        this.$message({
          type: 'warning',
          message: '收件地址不能为空'
        });
        return;
      }
      const firstProfessionType = this.selectedList[0].professionType;
      const consistentType = this.selectedList.every(
        item => item.professionType === firstProfessionType
      );
      if (!consistentType) {
        this.$message({
          type: 'warning',
          message: '不同交易结构不能合并开票，请先选择交易结构'
        });
        return;
      }
      const obj = {
        ...this.ruleForm,
        ...{
          selectedList: this.selectedList,
          curMoney: this.curMoney,
          totalAmount: this.tableResp.totalAmount
        },
        ...this.billInfo,
        ...{ addressInfo: this.addressInfo }
      };
      createExtend(openBill2, {
        billInfo: obj,
        invoiceOrderType: this.invoiceOrderType
      }).$on('confirm', () => {
        this.$emit('confirm');
        this.$emit('remove');
      });
    },
    professionFilter(profession) {
      return PROFESSION_TYPE.get(profession) || '-';
    }
  },
  watch: {
    is45: {
      immediate: true,
      handler(v) {
        v && (this.ruleForm.invoiceType = taxList[0].value);
      }
    },
    'searchQuery.supplierId': {
      immediate: true,
      async handler(v) {
        this.setEmpty += 1;
        let useSearchType = true;
        v &&
          (await this.searchTypeHistory({
            ...this.searchQuery
          }).then(res => {
            const lastTimeInfoArr = res.data.data;
            if (Array.isArray(lastTimeInfoArr) && lastTimeInfoArr.length > 0) {
              const [lastTimeInfo] = lastTimeInfoArr;
              this.ruleForm.invoiceType = lastTimeInfo.invoiceType;
              this.ruleForm.itemId = lastTimeInfo.itemId;
              this.ruleForm.itemName = lastTimeInfo.itemName;
              // 这个setTimeout 很关键，因为watch了invoiceType的变化，会重置initType，导致这儿赋值会失败，所以用setTimeout，开启宏任务，确保它会在watch的代码之后执行，前提是watch里没有setTimeout了，不然就是地狱难度
              setTimeout(() => {
                this.initType = {
                  id: lastTimeInfo.itemId,
                  itemName: lastTimeInfo.itemName
                };
              }, 0);
              useSearchType = false;
            }
          }));
        useSearchType &&
          (await this.searchType({ supplierId: v }).then(res => {
            let result = res.data.data;
            if (result && result.length) {
              //默认供应商选择后需要对应更改默认发票类别
              this.ruleForm.itemId = result[0].id;
              this.ruleForm.itemName = result[0].itemName;
              this.initType = result[0];
            }
          }));
      }
    },
    //发票类型改变清空开票类目
    'ruleForm.invoiceType'() {
      this.setEmpty += 1;
      this.initType = { id: '', itemName: '' };
    },
    'searchQuery.payPassagewayCode'() {
      this.searchEvent();
    },
    'searchQuery.payType'() {
      this.searchEvent();
    },
    'searchQuery.professionType'() {
      this.searchEvent();
    }
  },
  created() {
    invoice.queryDefaultAddressName().then(({ pdata }) => {
      this.addressInfo = pdata || {};
    });
    invoice.detail().then(({ pdata }) => {
      this.billInfo = pdata.csoInfo;
    });
  }
};
</script>
<style lang="scss" scoped>
.flexInfo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  img {
    max-width: 150px;
    margin-right: 10px;
  }
}
.colorBlock {
  font-size: 20px;
  line-height: 24px;
  display: flex;
  color: #2e2e2f;
  margin-bottom: 20px;
}
.colorBlock::before {
  content: '';
  width: 8px;
  height: 24px;
  background: #1989fa;
  margin-right: 5px;
  display: inline-block;
}
#openBill {
  .search-left {
    align-items: space-around;
    > div {
      display: flex;
      align-items: center;
      width: 400px;
      span {
        width: 100px;
        text-align: right;
      }
    }
    .search-input {
      margin-right: 0;
      input {
        padding: 0;
      }
    }
  }
  .totalMoney {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 15px;
    label {
      font-size: 14px;
      color: #666;
    }
    span {
      font-size: 20px;
      color: #333;
      margin-right: 80px;
    }
    span:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
